<script setup lang="ts">
import type { LibrarySearchViewMode } from '@/js/account/entities/document';
import { classNames } from '@/js/lib/bem';

const model = defineModel<LibrarySearchViewMode>({ required: true });

const cn = classNames('library-search-view-toggle');

const OPTIONS: Array<{ value: LibrarySearchViewMode, label: string }> = [
  { value: 'grouped', label: 'Grouped by document' },
  { value: 'flat', label: 'All matches' },
];
</script>

<template>
  <div :class="cn()" role="group" aria-label="Result view">
    <button
      v-for="option in OPTIONS"
      :key="option.value"
      type="button"
      :class="cn('option', { active: model === option.value })"
      :aria-pressed="model === option.value"
      @click="model = option.value"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.library-search-view-toggle {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  border-radius: 4px;
  background-color: var(--color-background-primary);

  &__option {
    padding: 8px 12px;
    border: none;
    border-radius: 3px;
    background: none;
    color: var(--color-text-secondary);
    font-family: inherit;
    font-size: 13px;
    font-weight: var(--font-weight-medium);
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;

    &:hover {
      color: var(--color-text-primary);
    }

    &_active {
      background-color: var(--color-white);
      color: var(--color-primary-dark);
      box-shadow: var(--shadow);
    }

    &:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 2px;
    }
  }

  @media (max-width: 768px) {
    &__option {
      flex: 1;
      min-height: 44px;
      white-space: normal;
    }
  }
}
</style>
